<div class="vipps-status">
  @if (status(); as status) {
    <div class="vipps-status__waiting">
      <dv-spinner size="md" color="brand"></dv-spinner>
      <div>{{ 'Vipps.WaitingForVipps' | translate }}</div>
    </div>
    @if (status === 'CREATED') {
      <div class="vipps-status__cancel" (click)="cancel.emit()">
        {{ 'Button.Cancel' | translate }}
      </div>
    }
  }
</div>
